import { latLngBounds } from "leaflet";

export class AutoSettings {
  constructor() {
    //      if (localStorage.getItem('settings')) {
    //          this.contents = JSON.parse(localStorage.getItem('settings'));
    //
    //     } else {
    this.contents = {
      tooltipsDisabled: false,
      showDirection: true,
      editMode: 0,
      bottomHeight: 200,
      bounds: null,
      ne: null,
      sw: null,
      stravakeyId: null,
      stravakeyPolicy: null,
      stravakeySignature: null,
    };
    //      }
    let vm = this;
    for (let property in this.contents) {
      Object.defineProperty(this, property, {
        get: function () {
          return vm.contents[property];
        },
        set: function (v) {
          vm.contents[property] = v;
        },
      });
    }
  }

  load() {
    if (localStorage.getItem("settings")) {
      this.contents = JSON.parse(localStorage.getItem("settings"));
      if (this.contents.ne) {
        this.contents.bounds = latLngBounds(this.contents.ne, this.contents.sw);
      }
    }
  }

  save() {
    let sett = this.contents;
    if (this.contents.bounds) {
      sett.ne = this.contents.bounds.getNorthEast();
      sett.sw = this.contents.bounds.getSouthWest();
    }
    localStorage.setItem("settings", JSON.stringify(sett));
  }

  copy(from) {
    for (let property in this.contents) {
      this.contents[property] = from.contents[property];
    }
  }

  update(s) {
    this.contents = s.contents;
    this.save();
  }
}
